import SolutionsCards3D from "./three/SolutionsCards3D";
import SolutionCardHover3D from "./three/SolutionCardHover3D";

// Point d'entrée esbuild dédié (bundle-solutions.min.js), chargé conditionnellement via le
// post-meta "has_solutions_3d" (cf. inc/scripts-styles-queue.php) — même principe que
// app/js/HomeBanner.js pour la bannière home 3D : Three.js reste hors du bundle principal.
document.addEventListener("DOMContentLoaded", () => {
	const themeLink = (window.skArgs && window.skArgs.themeLink) || "";
	const modelUrl = `${themeLink}/models/solution-card.glb`;

	const canvases = document.querySelectorAll("canvas[data-solutions-3d]");
	canvases.forEach((canvas) => {
		const root = canvas.closest(".block");
		const dataItems = root ? root.querySelectorAll(".solutions-3d-data [data-solutions-card]") : [];
		if (!dataItems.length) return;

		const cards = Array.from(dataItems).map((el) => ({
			tag: el.dataset.tag || "",
			icon: el.dataset.icon,
			logo: el.dataset.logo,
			link: el.dataset.link,
		}));

		const mode = canvas.dataset.mode === "auto" ? "auto" : "synced";
		const instance = new SolutionsCards3D(canvas, { cards, mode, modelUrl });

		window.dispatchEvent(new CustomEvent("solutionsCards3dReady", { detail: { root, instance } }));
	});

	// Grille de cartes de l'archive solutions : une carte 3D statique par carte, montée/démontée
	// au fil du scroll (IntersectionObserver) pour ne garder que quelques contextes WebGL actifs à
	// la fois, quel que soit le nombre de solutions affichées sur la page.
	const hoverCanvases = document.querySelectorAll("canvas[data-solution-card-hover]");
	if (hoverCanvases.length) {
		const instances = new Map();

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const canvas = entry.target;
					if (entry.isIntersecting) {
						if (!instances.has(canvas)) {
							const card = {
								tag: canvas.dataset.tag || "",
								icon: canvas.dataset.icon,
								logo: canvas.dataset.logo,
							};
							instances.set(canvas, new SolutionCardHover3D(canvas, { card, modelUrl }));
						}
					} else if (instances.has(canvas)) {
						instances.get(canvas).destroy();
						instances.delete(canvas);
					}
				});
			},
			{ rootMargin: "30% 0px" }
		);

		hoverCanvases.forEach((canvas) => observer.observe(canvas));
	}
});
